// import React from "react";

// const Footer = () => {
//   return (
//     <footer style={footerStyles}>
//       <div style={containerStyles}>
//         <div style={columnStyles}>
//           <h3 style={headingStyles}>Address</h3>
//           <p style={textStyles}>
//             Shirilari Vidyalay Eng Med High School, Ugar K
//             <br />
//             Post – UgarKhurd
//             <br />
//             Taluka – Kagawad, Dist - Belagavi
//             <br />
//             Pincode – 59396
//           </p>
//         </div>

//         <div style={columnStyles}>
//           <h3 style={headingStyles}>Quick Links</h3>
//           <ul style={listStyles}>
//             <li style={listItemStyles}><a href="#" style={linkStyles}>Home</a></li>
//             <li style={listItemStyles}><a href="#" style={linkStyles}>About</a></li>
//             <li style={listItemStyles}><a href="#" style={linkStyles}>School CBSE</a></li>
//             <li style={listItemStyles}><a href="#" style={linkStyles}>Curriculum</a></li>
//             <li style={listItemStyles}><a href="#" style={linkStyles}>Facilities</a></li>
//             <li style={listItemStyles}><a href="#" style={linkStyles}>Disclosures</a></li>
//             <li style={listItemStyles}><a href="#" style={linkStyles}>Gallery</a></li>
//           </ul>
//         </div>

//         <div style={columnStyles}>
//           <h3 style={headingStyles}>Open Hours</h3>
//           <p style={textStyles}>
//             Monday – Friday<br />
//             10:30 am to 4.45 pm<br /><br />
//             Saturday<br />
//             07:45 am to 11:45 am
//           </p>
//         </div>

//         <div style={columnStyles}>

//           <div style={{ width: '100%', maxWidth: '100%', height: '450px', margin: '20px 0' }}>
//       <iframe
//         title="School Location"
//         src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3458.482624103827!2d74.75327419999999!3d16.6895039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc0d9c436fd92ad%3A0x4c134bd49aa38227!2sVidyanand%20English%20Medium%20School!5e1!3m2!1sen!2sin!4v1749727028406!5m2!1sen!2sin"
//         width="100%"
//         height="100%"
//         style={{ border: 0 }}
//         allowFullScreen=""
//         loading="lazy"
//         referrerPolicy="no-referrer-when-downgrade"
//       ></iframe>
//     </div>
//         </div>
//       </div>

//       <div style={copyrightStyles}>
//         <p style={copyrightTextStyles}>
//           © {new Date().getFullYear()} Shirilari Vidyalay Eng Med High School. All Rights Reserved.
//         </p>
//       </div>
//     </footer>
//   );
// };

// // Internal CSS Styles
// const footerStyles = {
//   backgroundColor: '#2c3e50',
//   color: '#ecf0f1',
//   padding: '40px 0 0',
//   fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
// };

// const containerStyles = {
//   maxWidth: '1200px',
//   margin: '0 auto',
//   padding: '0 20px',
//   display: 'flex',
//   flexWrap: 'wrap',
//   justifyContent: 'space-between',
// };

// const columnStyles = {
//   flex: '1',
//   minWidth: '250px',
//   marginBottom: '30px',
//   padding: '0 15px',
// };

// const headingStyles = {
//   fontSize: '18px',
//   marginBottom: '20px',
//   position: 'relative',
//   paddingBottom: '10px',
// };

// const textStyles = {
//   fontSize: '14px',
//   lineHeight: '1.6',
//   margin: '0 0 15px',
// };

// const listStyles = {
//   listStyle: 'none',
//   padding: '0',
//   margin: '0',
// };

// const listItemStyles = {
//   marginBottom: '10px',
// };

// const linkStyles = {
//   color: '#bdc3c7',
//   textDecoration: 'none',
//   transition: 'color 0.3s ease',
//   fontSize: '14px',
// };

// const newsletterStyles = {
//   display: 'flex',
//   marginTop: '20px',
// };

// const inputStyles = {
//   flex: '1',
//   padding: '10px',
//   border: 'none',
//   borderRadius: '4px 0 0 4px',
//   fontSize: '14px',
// };

// const buttonStyles = {
//   padding: '10px 15px',
//   backgroundColor: '#e74c3c',
//   color: 'white',
//   border: 'none',
//   borderRadius: '0 4px 4px 0',
//   cursor: 'pointer',
//   transition: 'background-color 0.3s ease',
// };

// const copyrightStyles = {
//   backgroundColor: '#1a252f',
//   padding: '20px 0',
//   textAlign: 'center',
// };

// const copyrightTextStyles = {
//   margin: '0',
//   fontSize: '14px',
//   color: '#95a5a6',
// };

// // Add hover effects
// Object.assign(linkStyles, {
//   ':hover': {
//     color: '#e74c3c',
//   }
// });

// Object.assign(buttonStyles, {
//   ':hover': {
//     backgroundColor: '#c0392b',
//   }
// });

// Object.assign(headingStyles, {
//   ':after': {
//     content: '""',
//     position: 'absolute',
//     left: '0',
//     bottom: '0',
//     width: '50px',
//     height: '2px',
//     backgroundColor: '#e74c3c',
//   }
// });

// export default Footer;











import React from "react";
import { FaMapMarkerAlt, FaClock, FaPhone, FaEnvelope, FaFacebook, FaTwitter, FaInstagram, FaYoutube, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-container">
          {/* School Information Column */}
          <div className="footer-column">
            <h3 className="footer-heading">
              <FaMapMarkerAlt className="footer-icon" /> Address
            </h3>
            <div className="footer-content address-content">
              <p>Acharya Shri Vidyanand English Medium School, Shedbal</p>
              <p>At Post Shedbal – Arihant Nagar</p>
              <p>Taluka – Kagwad, Dist - Belagavi</p>
              <p>Pincode – 591315</p>
              <p>State – Karnataka</p>

              <div className="contact-info">
                <p><FaPhone className="contact-icon" /> +91 9964801008</p>
                <p><FaEnvelope className="contact-icon" /> vidyabhushan1008@gmail.com</p>
              </div>
            </div>
          </div>

          {/* Quick Links Column */}
          <div className="footer-column">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about-school">About School</a></li>
              <li><a href="/CBSEDisclosures">CBSE Disclosures</a></li>
              <li><a href="/AcademicStudentView">Academics</a></li>
              <li><a href="/Gallery">Gallery</a></li>
              <li><a href="/Facilities">Facilities</a></li>
            </ul>
          </div>

          {/* Opening Hours Column */}
          <div className="footer-column">
            <h3 className="footer-heading">
              <FaClock className="footer-icon" /> School Schedule
            </h3>
            <div className="footer-content">
              <div className="timing">
                <p className="days">Monday – Friday</p>
                <p className="hours">08:15 AM to 3:10 PM</p>
              </div>
              <div className="timing">
                <p className="days">Saturday</p>
                <p className="hours">08:15 AM to 12:30 PM</p>
              </div>
            </div>
          </div>

          {/* Map Column */}
          <div className="footer-column">
            <h3 className="footer-heading">Our Location</h3>
            <div className="map-container">
              <iframe
                title="School Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3458.482624103827!2d74.75327419999999!3d16.6895039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc0d9c436fd92ad%3A0x4c134bd49aa38227!2sVidyanand%20English%20Medium%20School!5e1!3m2!1sen!2sin!4v1749727028406!5m2!1sen!2sin"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-container">
          <div className="copyright">
            © {new Date().getFullYear()} Vidyabhushan Minority Educational Institute. All Rights Reserved.
          </div>

          <div className="social-links">
            <a href="https://www.facebook.com/profile.php?id=100094016441068" aria-label="Facebook"><FaFacebook /></a>
            <a href="https://www.youtube.com/@ASVEM_SCHOOL_SHEDBAL" aria-label="YouTube"><FaYoutube /></a>
            <a
              href="https://wa.me/919964801008"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <FaWhatsapp /> 
            </a>


          </div>
        </div>
      </div>

      <style>{`
  /* Modern Footer Design */
  .footer {
    background: #0a192f;
    color: #ccd6f6;
    font-family: 'Inter', sans-serif;
    border-top: 1px solid rgba(100, 255, 218, 0.1);
  }
  
  .footer-top {
    padding: 70px 0 50px;
  }
  
  .footer-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 30px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 40px;
  }
  
  /* Footer Headings with Gradient Text */
  .footer-heading {
    font-size: 1.4rem;
    margin-bottom: 25px;
    font-weight: 600;
    background: linear-gradient(90deg, #64ffda, #57cbff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-flex;
    align-items: center;
  }

  .footer-icon {
    margin-right: 10px;
    color: #64ffda;
    -webkit-text-fill-color: #64ffda;
  }

  .address-content p {
    margin: 4px 0;
    color: #8892b0;
    font-size: 0.95rem;
    line-height: 1.4;
  }
  
  /* Contact Info */
  .contact-info {
    margin-top: 20px;
  }

  .contact-info p {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    line-height: 1.6;
    color: #ccd6f6;
  }
  
  .contact-icon {
    margin-right: 12px;
    color: #64ffda;
    -webkit-text-fill-color: #64ffda;
  }
  
  /* Links with Hover Effect */
  .footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .footer-links li {
    margin-bottom: 15px;
  }
  
  .footer-links a {
    color: #8892b0;
    text-decoration: none;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    position: relative;
    padding-bottom: 3px;
  }
  
  .footer-links a:before {
    content: '';
    position: absolute;
    width: 0;
    height: 1px;
    bottom: 0;
    left: 0;
    background-color: #64ffda;
    visibility: hidden;
    transition: all 0.3s ease-in-out;
  }
  
  .footer-links a:hover {
    color: #e6f1ff;
  }
  
  .footer-links a:hover:before {
    visibility: visible;
    width: 100%;
  }
  
  /* Opening Hours */
  .timing {
    margin-bottom: 20px;
  }
  
  .days {
    color: #64ffda;
    font-weight: 500;
    margin-bottom: 5px;
  }
  
  .hours {
    color: #8892b0;
    margin: 0;
  }
  
  /* Map Container */
  .map-container {
    height: 250px;
    width: 100%;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid rgba(100, 255, 218, 0.1);
    transition: transform 0.3s ease;
  }
  
  .map-container:hover {
    transform: translateY(-5px);
  }
  
  .map-container iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
  
  /* Footer Bottom */
  .footer-bottom {
    border-top: 1px solid rgba(100, 255, 218, 0.1);
    padding: 25px 0;
  }
  
  .footer-bottom .footer-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .copyright {
    font-size: 0.9rem;
    color: #8892b0;
  }
  
  .social-links {
    display: flex;
    gap: 20px;
    
  }
  
  .social-links a {
    color: #ccd6f6;
    transition: all 0.3s ease;
    font-size: 1.8rem;
  }
  
  .social-links a:hover {
    color: #64ffda;
    transform: translateY(-3px);
  }
  
  /* Responsive Adjustments */
  @media (max-width: 768px) {
    .footer-top {
      padding: 50px 0 30px;
    }
    
    .footer-container {
      grid-template-columns: 1fr;
      gap: 30px;
      padding: 0 20px;
    }
    
    .footer-bottom .footer-container {
      flex-direction: column;
      gap: 15px;
      text-align: center;
    }
    
    .map-container {
      height: 250px;
    }
  }
`}</style>
    </footer>
  );
};

export default Footer;